import AOS from 'aos';

let isAOSEnabled = false; // Default state.
const BREAKPOINT = 1200; // Screen width breakpoint

const aosOptions = {
	// Centralized config
	startEvent: 'DOMContentLoaded',
	initClassName: 'aos-init',
	animatedClassName: 'aos-animate',
	useClassNames: false,
	disableMutationObserver: false,
	debounceDelay: 50,
	throttleDelay: 99,
	offset: 120,
	duration: 600,
	easing: 'ease',
	once: true,
	mirror: false,
	anchorPlacement: 'center-bottom',
};

function shouldEnableAOS() {
	return window.innerWidth >= BREAKPOINT;
}

function showAllAOSElements() {
	const aosElements = document.querySelectorAll('[data-aos]');
	aosElements.forEach((element) => {
		element.style.opacity = '1';
		element.style.transform = 'none';
		element.style.visibility = 'visible';
	});
}

function initializeAOS() {
	if (shouldEnableAOS()) {
		AOS.init(aosOptions);
		isAOSEnabled = true;
	} else {
		showAllAOSElements();
	}
}

// Handle window resize
function handleResize() {
	if (shouldEnableAOS() && !isAOSEnabled) {
		initializeAOS();
	} else if (!shouldEnableAOS() && isAOSEnabled) {
		disableAOS();
		showAllAOSElements();
	}
}

// Add resize listener
window.addEventListener('resize', handleResize);

function disableAOS() {
	AOS.refreshHard(); // Refreshing Hard seems to reset all AOS.
	isAOSEnabled = false;
	showAllAOSElements();
}

function toggleAOSAnimations() {
	const aosElements = document.querySelectorAll('[data-aos], [data-aos-disabled]');
	const toggleButton = document.getElementById('toggleAOS');

	aosElements.forEach((element) => {
		if (isAOSEnabled) {
			// Disable AOS on the element
			if (element.hasAttribute('data-aos')) {
				element.setAttribute('data-aos-disabled', element.getAttribute('data-aos'));
				element.removeAttribute('data-aos');
			}
		} else {
			// Enable AOS on the element
			if (element.hasAttribute('data-aos-disabled')) {
				element.setAttribute('data-aos', element.getAttribute('data-aos-disabled'));
				element.removeAttribute('data-aos-disabled');
			}
		}
	});

	isAOSEnabled = !isAOSEnabled; // Toggle the state

	AOS.refreshHard(); // Reinitialize AOS to apply changes

	updateToggleButtonText(toggleButton);
}

function updateToggleButtonText(toggleButton) {
	if (!isAOSEnabled) {
		toggleButton.querySelector('span').textContent = 'Enable Animations on Scroll';
	} else {
		toggleButton.querySelector('span').textContent = 'Disable Animations on Scroll';
	}
}

export { initializeAOS, toggleAOSAnimations };
